// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';

export default class ProductOrderDetailed {
    constructor(args) {
        args = toCamelCaseProperties(args) || {}
        this.address = args.address || ''
        this.chainId = args.chainId || 0
        this.childOrderId = args.childOrderId || 0
        this.city = args.city || ''
        this.comment = args.comment || ''
        this.createdTime = args.createdTime || ''
        this.email = args.email || ''
        this.fullName = args.fullName || ''
        this.guid = args.guid || ''
        this.id = args.id || 0 
        this.isDeleted = args.isDeleted || false
        this.orderNumber = args.orderNumber || ''
        this.parentOrderId = args.parentOrderId || 0
        this.paymentMethodId = setPaymentMethodIdType(args.paymentMethodId) || 'UNKNOWN'
        this.phoneNumber = args.phoneNumber || ''
        this.postNumber = args.postNumber || ''
        this.onlineSluttkundeId = args.onlineSluttkundeId || 0
        this.orderShippingInclVat = args.orderShippingInclVat || 0
        this.orderSubtotalInclVat = args.orderSubtotalInclVat || 0
        this.orderStatusId = setOrderStatusIdType(args.orderStatusId) || ''
        this.parentOrderNumber= args.parentOrderNumber || ''
        this.products = args.products || []
        this.salonInfo = args.salonInfo || null
        this.salonName = args.salonName || ''
        this.shippingMethodId = args.shippingMethodId || ''
        this.shippingStatusId = setShippingStatusType(args.shippingStatusId) || setShippingStatusType(0)
        this.siteId = args.siteId || 0
        this.total = args.total || 0
        this.totalDiscount = args.totalDiscount || 0
        this.totalVat = args.totalVat || 0
        this.trackingNumber = args.trackingNumber || ''
        this.shippingInfo = args.shippingInfo || null
        this.invoiceFullName = args.invoiceFullName || ''
        this.invoiceAddress = args.invoiceAddress || ''
        this.invoicePostNumber = args.invoicePostNumber || ''
        this.invoiceCity = args.invoiceCity || ''
        this.billingAddressId = args.billingAddressId || 0
        // this.childOrderNumber= args.childOrderNumber || ''
        this.customer = args.customer || {}
        this.fixitGuid = args.fixitGuid || ''
        this.lastModifiedBy = args.lastModifiedBy || ''
        // this.orderShippingExclVat= args.orderShippingExclVat || 0
        // this.orderSubTotalDiscountExclVat= args.orderSubTotalDiscountExclVat || 0
        // this.orderSubTotalDiscountInclVat= args.orderSubTotalDiscountInclVat || 0
        // this.orderSubtotalExclVat= args.orderSubtotalExclVat || 0
        // this.orderSubtotalInclVat= args.orderSubtotalInclVat || 0
        // this.paymentTransactionId= args.paymentTransactionId || ''
        // this.pickupInStore= args.pickupInStore || false
        // this.pickupPointId= args.pickupPointId || 0
        // this.refundedAmount= args.refundedAmount || 0
        // this.reservationId= args.reservationId || ''
        // this.shippingAddressId= args.shippingAddressId || 0
        // this.providerId= args.shippingProviderId || 1
        // this.transaction= args.transaction || {}
        // this.updatedTime= args.updatedTime || ''
	}

	assign(order) {
		Object.assign(this, toCamelCaseProperties(order));
	}
}
function setOrderStatusIdType(orderStatusId){
    switch(orderStatusId) {
        case 0: return '';
        case 1: return 'New';
        case 2: return 'Picked';
        case 3: return 'FinishedPicking';
        case 4: return 'ReadyForShipment';
        case 5: return 'Sent';
        case 6: return 'Delivered';
        case 7: return 'NewReturn';
        case 8: return'ReturnChecked';
        case 9: return 'Credited';
        case 10: return 'Cancelled';
    }
}
function setPaymentMethodIdType(paymentMethodId){
    switch(paymentMethodId) {
        case 0: return 'CARD'
        case 1: return 'VIPPS'
        case 2: return 'INVOICE'
        case 3: return 'INSTALLMENT'
        case 4: return 'VIPPS_DIRECT'
        case 5: return 'KLARNA'
        case 6: return 'APPLE_PAY'
        case 7: return 'GOOGLE_PAY'
        case 100: return 'UNKNOWN'
    }
}
function setShippingStatusType(shippingStatusType) {
    switch (shippingStatusType) {
        case 0: return ''; 
        case 1: return 'Attempted-delivery'
        case 2: return 'Customs'
        case 3: return 'Collected'
        case 4: return 'Delivered'
        case 5: return 'Delivered-sender'
        case 6: return 'Delivery-cancelled'
        case 7: return 'Delivery-changed'
        case 8: return 'Delivery-ordered'
        case 9: return 'Deviation'
        case 10: return 'Handed-in'
        case 11: return 'International'
        case 12: return 'In-transit'
        case 13: return 'Notification-sent'
        case 14: return 'Pre-notified'
        case 15: return 'Ready-for-pickup'
        case 16: return 'Return'
        case 17: return 'Transport-to-recipient'
        case 18: return 'Terminal'
        case 19: return 'Expired'
    }
}